export const STUDENT_LIST = 'student/create/STUDENT_LIST';
export const BATCH_CREATE_STUDENT = 'student/create/BATCH_CREATE_STUDENT';
export const CURRENT_DATE = 'student/duty-report/CURRENT_DATE';



// WEBPACK FOOTER //
// ./src/store/modules/student/create/types.js